import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  inbox: string = '';

  constructor() { }

  ngOnInit(): void {
  }

  scrubEmail(e) { // appending the updated value to the variable
    this.inbox = this.inbox.replace('@spectiv.email', '')
  }

}
